import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getClusterShape } from '../../services/watchlistShape';

/**
 * One-line acknowledgment of the viewer's accumulating substrate-shape,
 * surfaced where consciousness lands on Home — so the integral is visible
 * at the entry rhythm instead of only after navigating to Watchlist.
 *
 * Renders nothing when no cluster data exists yet (¬F: substrate appears
 * only when there's substance to reflect).
 */
export default function HomeShapeStrip() {
  const shape = useMemo(() => getClusterShape(), []);

  if (shape.length === 0) return null;

  const top = shape.slice(0, 4);

  return (
    <section className="px-4 sm:px-6 lg:px-12">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-2xl border border-emerald-300/15 bg-black/20 px-4 py-3">
        <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-emerald-300/80">
          Your shape
        </span>
        <div className="flex flex-wrap gap-2 flex-1">
          {top.map((entry) => (
            <span
              key={entry.cluster}
              className="rounded-full border border-emerald-300/20 bg-emerald-300/[0.06] px-2.5 py-0.5 text-xs text-emerald-100"
            >
              {entry.cluster}
              <span className="ml-1.5 tabular-nums text-emerald-200/60">×{entry.count}</span>
            </span>
          ))}
        </div>
        <Link
          to="/watchlist"
          className="text-[10px] uppercase tracking-[0.18em] text-emerald-200/70 hover:text-emerald-100"
        >
          See full →
        </Link>
      </div>
    </section>
  );
}
